/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import React from 'react';
import PropTypes from 'prop-types';
import { RaisedButton } from 'material-ui';
import { connect } from 'react-redux';
import { RequestType } from './types';
import { requestChangeStatus } from './RequestState';
import withWidth, { SMALL } from '../../utils/withWidth';
import { localize } from '../../i18n';

const ChangeStatusButton = localize((props) => {
  const {
    type,
    icon,
    request,
    onClick,
  } = props;

  const actionTypes = {
    ack: {
      colors: {
        background: '#e66b2f',
        color: 'white',
      },
      setStatus: 'acknowledged',
      title: props.t('Acknowledge'),
    },
    close: {
      colors: {
        background: '#c31f3b',
        color: 'white',
      },
      setStatus: 'closed',
      title: props.t('Close'),
    },
  };

  const btnStyle = (actiontype, disabled) => ({
    fontSize: '11px',
    lineHeight: '33px',
    height: '33px',
    fontWeight: '500',
    textTransform: 'uppercase',
    ...(disabled ? {} : actionTypes[actiontype].colors),
  });

  const { title } = actionTypes[type];
  const setStatus = actionTypes[type].setStatus;
  const disabled = request.status === setStatus;

  return (
    <RaisedButton
      fullWidth
      disabled={disabled}
      buttonStyle={btnStyle(type, disabled)}
      onClick={() => onClick(request._id, setStatus, request.status)}
    >
      <i className="material-icons" style={{ color: disabled ? 'graytext' : 'white', marginRight: '.2em' }}>{icon}</i>
      {title}
    </RaisedButton>
  );
});

ChangeStatusButton.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  request: RequestType,
  onClick: PropTypes.func,
  t: PropTypes.func,
};

const RequestQuickStatus = function RequestQuickStatus(props) {
  const {
    request,
    changeStatus,
    onAction,
    width,
  } = props;

  const isModile = width <= SMALL;

  const handleChangeStatus = (...args) => {
    changeStatus(...args);
    onAction();
  };

  return (
    <div className="uk-grid RequestsQuickStatus" style={{ paddingTop: isModile ? 27 : 16 }}>
      <div className="uk-width-small-1-2 uk-width-mobile-1-2 uk-text-center">
        <ChangeStatusButton type="ack" request={request} icon="check_circle" onClick={handleChangeStatus} />
      </div>
      <div className="uk-width-small-1-2 uk-width-mobile-1-2 uk-text-center">
        <ChangeStatusButton type="close" request={request} icon="close" onClick={handleChangeStatus} />
      </div>
    </div>
  );
};

RequestQuickStatus.propTypes = {
  request: RequestType,
  changeStatus: PropTypes.func,
  onAction: PropTypes.func,
  width: PropTypes.number,
};

const dispatchToProps = dispatch => ({
  changeStatus(...args) {
    dispatch(requestChangeStatus(...args));
  },
});

export default connect(null, dispatchToProps)(withWidth()(RequestQuickStatus));



// WEBPACK FOOTER //
// ./src/views/requests/RequestQuickStatus.js